module.exports = __webpack_public_path__ + "img/yacon-350x184.80bdcb57.jpg";